import "./index.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "auth";
import { App } from "app";
import * as serviceWorker from "./serviceWorker";

const firebaseConfig = {
  apiKey: "AIzaSyDhIcy25nO5-r4YmOh4wDCdW2OVbQyj8zk",
  authDomain: "true4u-dev.firebaseapp.com",
  databaseURL: "https://true4u-dev.firebaseio.com",
  projectId: "true4u-dev",
  storageBucket: "true4u-dev.appspot.com",
  messagingSenderId: "246705370943",
  appId: "1:246705370943:web:3b00d6d17759e5910a458a",
  measurementId: "G-L5LQZ758JL",
};
window.firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <App />
      </Router>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
